import { CLOVER_RECEIPTS } from '../actionTypes';

export const fetchCloverReceipts = (action) => ({
  type: CLOVER_RECEIPTS.FETCH,
  payload: action.payload,
});
